import { useTranslation } from "react-i18next";

import { Breadcrumbs } from "./components/Breadcrumbs.jsx";

export function ExcludedStep({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="wp:mx-auto wp:max-w-xl">
      <Breadcrumbs current={2} />
      <h1 className="wp:mb-6 wp:text-3xl wp:font-normal wp:tracking-tight wp:[color:var(--wf-text-color,#111827)] wp:md:text-4xl">
        {t("proxy.withdrawals.excluded.title")}
      </h1>
      <div className="wp:mb-8 wp:rounded-md wp:border wp:border-solid wp:border-blue-200 wp:bg-blue-50 wp:p-6 wp:text-base wp:text-blue-900">
        {t("proxy.withdrawals.excluded.message")}
      </div>
      <button
        type="button"
        onClick={onBack}
        className="wp:flex wp:w-full wp:cursor-pointer wp:items-center wp:justify-center wp:rounded-md wp:border wp:border-solid wp:border-gray-300 wp:bg-white wp:px-6 wp:py-4 wp:text-lg wp:font-medium wp:text-gray-700 wp:shadow-sm"
      >
        {t("proxy.withdrawals.common.actions.back")}
      </button>
    </div>
  );
}
